import Skeleton from "@/src/sb/components/Skeleton"

export const SearchResultSkeleton = () => (
  <div className="flex capitalize flex-row justify-between items-start py-2.5 border-b border-[#202429] hover:bg-[#1A1D21] cursor-pointer">
    <div className="flex flex-row gap-2 items-center px-5">
      <section className="flex flex-col gap-2">
        <div className="flex flex-row gap-2 items-center">
          <Skeleton height={20} width={20} />{" "}
          <Skeleton width={245} height={12} />
        </div>
        <section className="text-[#9CA3AF] !text-[10px] flex flex-col items-center">
          <div className="flex items-center gap-2 pl-7">
            {Array.from({ length: 3 }).map((_, index) => (
              <Skeleton width={77} height={10} key={index} />
            ))}
          </div>
        </section>
      </section>
    </div>
    <div className={"px-5"}>
      <Skeleton width={100} height={12} />
    </div>
  </div>
)
